export default __webpack_public_path__ + "static/media/property_252.056ba414.png";